import React, { useEffect, useState } from "react"
import { useOutletContext } from "react-router-dom"
import axios from "axios"
import { FaPlus, FaSave, FaTrash, FaTrophy } from "react-icons/fa"

const TIPOS = [
  { value: "vaqueiro", label: "Vaqueiro" },
  { value: "esteireiro", label: "Esteireiro" },
  { value: "cavaloPuxada", label: "Cavalo Puxar" },
  { value: "cavaloEsteira", label: "Cavalo Esteira" },
]

export default function CircuitoCampeoesPainel() {
  const { circuito } = useOutletContext()
  const circuitoId = circuito?._id

  // Estados dos Filtros / Formulário
  const [categoria, setCategoria] = useState("")
  const [tipo, setTipo] = useState("vaqueiro")
  const [posicao, setPosicao] = useState(1)
  const [participanteIdentifier, setParticipanteIdentifier] = useState("") // 💡 Agora aceita ID ou Nome
  const [foto, setFoto] = useState(null)

  const [lista, setLista] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (circuito?.categorias?.length > 0 && !categoria) {
      setCategoria(circuito.categorias[0].nome || circuito.categorias[0])
    }
  }, [circuito])

  const participantesRanking = circuito?.participantes?.filter(p => p.categoria === categoria && p.tipo === tipo) || [];

  const carregarCampeoes = async () => {
    try {
      if (!circuitoId || !categoria || !tipo) return
      const res = await axios.get(
        `https://api.ticketdovaqueiro.com/api/circuitos/${circuitoId}/campeoes?categoria=${categoria}&tipo=${tipo}`
      )
      setLista(res.data || [])
    } catch (e) {
      setLista([])
    }
  }

  useEffect(() => {
    carregarCampeoes()
    setParticipanteIdentifier("")
  }, [circuitoId, categoria, tipo])

  const salvarCampeao = async () => {
    try {
      if (!circuitoId) return alert("Aguarde a página terminar de carregar o circuito.");
      if (!participanteIdentifier) return alert("Selecione um participante do ranking.");

      setLoading(true)

      // 💡 Busca o competidor no array, não importa se é pelo ID ou pelo Nome
      const competidorSelecionado = participantesRanking.find(p => 
          String(p._id) === String(participanteIdentifier) || p.nome === participanteIdentifier
      );

      if (!competidorSelecionado) return alert("Erro ao identificar competidor.");

      const form = new FormData()
      form.append("categoria", categoria)
      form.append("tipo", tipo)
      form.append("posicao", String(posicao))
      
      // 💡 Envia sempre o ID (se tiver) e OBRIGATORIAMENTE o Nome
      form.append("participanteId", competidorSelecionado._id || competidorSelecionado.nome)
      form.append("participanteNome", competidorSelecionado.nome)

      if (foto) form.append("foto", foto)

      await axios.post(`https://api.ticketdovaqueiro.com/api/circuitos/${circuitoId}/campeoes`, form)
      
      alert("Campeão salvo com sucesso!")
      setFoto(null)
      setParticipanteIdentifier("")
      carregarCampeoes()
    } catch (e) {
      console.error(e);
      alert(e.response?.data?.erro || "Erro interno no servidor.");
    } finally {
      setLoading(false)
    }
  }

  const deletar = async (id) => {
    if (!window.confirm("Excluir esse campeão?")) return
    try {
      await axios.delete(`https://api.ticketdovaqueiro.com/api/circuitos/${circuitoId}/campeoes/${id}`)
      carregarCampeoes()
    } catch (e) {
      alert("Erro ao excluir")
    }
  }

  return (
    <div>
      <div className="pc-page-header">
        <h1 className="pc-page-header__title">
          <FaTrophy style={{ marginRight: 12, color: "var(--pc-accent)" }} />
          Hall dos Campeões
        </h1>
        <p className="pc-page-header__subtitle">Defina os campeões globais de cada categoria</p>
      </div>

      <div className="pc-card">
        <div className="pc-card__header"><h3 className="pc-card__title">Selecione a Categoria de Visualização</h3></div>
        <div className="pc-form-row">
          <div className="pc-form-group">
            <label className="pc-label">Categoria do Circuito</label>
            <select className="pc-select" value={categoria} onChange={(e) => setCategoria(e.target.value)}>
              {circuito?.categorias?.map((c, i) => {
                 const catName = c.nome || c;
                 return <option key={i} value={catName}>{catName}</option>
              })}
            </select>
          </div>

          <div className="pc-form-group">
            <label className="pc-label">Tipo de Competidor</label>
            <select className="pc-select" value={tipo} onChange={(e) => setTipo(e.target.value)}>
              {TIPOS.map((t) => <option key={t.value} value={t.value}>{t.label}</option>)}
            </select>
          </div>
        </div>
      </div>

      <div className="pc-card">
        <div className="pc-card__header">
          <h3 className="pc-card__title"><FaPlus style={{ marginRight: 10 }} /> Adicionar / Substituir Campeão</h3>
        </div>

        <div className="pc-form-row">
          <div className="pc-form-group">
            <label className="pc-label">Posição</label>
            <select className="pc-select" value={posicao} onChange={(e) => setPosicao(Number(e.target.value))}>
              <option value={1}>1º Lugar</option>
              <option value={2}>2º Lugar</option>
              <option value={3}>3º Lugar</option>
              <option value={4}>4º Lugar</option>
              <option value={5}>5º Lugar</option>
            </select>
          </div>

          <div className="pc-form-group">
            <label className="pc-label">Vincular Competidor do Ranking *</label>
            <select className="pc-select" value={participanteIdentifier} onChange={(e) => setParticipanteIdentifier(e.target.value)}>
               <option value="">-- Selecione o competidor --</option>
               {participantesRanking.sort((a,b) => b.pontos - a.pontos).map((p, idx) => {
                  // 💡 A MÁGICA: Se não tem ID, a opção assume o Nome do vaqueiro como chave!
                  const val = p._id ? String(p._id) : p.nome;
                  return <option key={idx} value={val}>{p.nome} - {p.pontos} pts</option>
               })}
            </select>
            {participantesRanking.length === 0 && <small style={{color: "#ef4444", marginTop: 4}}>Nenhum competidor cadastrado nesta categoria no Ranking.</small>}
          </div>
        </div>

        <div className="pc-form-group">
          <label className="pc-label">Foto do Campeão</label>
          <input type="file" accept="image/*" onChange={(e) => setFoto(e.target.files[0])} className="pc-file-input" />
        </div>

        <button onClick={salvarCampeao} disabled={loading || !participanteIdentifier} className="pc-btn pc-btn--primary">
          <FaSave /> {loading ? "Salvando..." : "Salvar Campeão"}
        </button>
      </div>

      <div className="pc-card">
        <div className="pc-card__header"><h3 className="pc-card__title">Hall Atual - {categoria} ({tipo})</h3></div>
        {lista.length === 0 ? (
          <div className="pc-empty">Nenhum campeão cadastrado para esta seleção.</div>
        ) : (
          <div className="pc-list">
            {lista.map((c) => (
              <div key={c._id} className="pc-list-item" style={{ alignItems: "center" }}>
                {c.foto && <img src={`https://api.ticketdovaqueiro.com/uploads/${c.foto}`} alt="" style={{width: 50, height: 50, borderRadius: "50%", objectFit: "cover", marginRight: 15}} />}
                <div className="pc-list-item__content">
                  <h4 className="pc-list-item__title">{c.posicao}º Lugar - {c.nome}</h4>
                  <p className="pc-list-item__subtitle" style={{color: "var(--pc-accent)", fontWeight: "bold"}}>{c.pontos} Pontos Acumulados</p>
                </div>
                <div className="pc-list-item__actions">
                  <button onClick={() => deletar(c._id)} className="pc-btn pc-btn--danger pc-btn--sm"><FaTrash /> Excluir</button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}